import { AddressDetailsModel } from '../client/client.model';

export class UpdateAdvisorSubscription {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  officePhoneNumber: string;
  email: string;
  address: AddressDetailsModel = new AddressDetailsModel();
  addons: string[];
  package: string;
}
